import {
  Actions,
  PrepAndSendAction,
  User,
} from 'hellospa/page/prep-and-send/data/types';

export const setUser = (
  user: Partial<User>,
): PrepAndSendAction => ({
  type: Actions.UpdateUser,
  payload: user,
});
